function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e4783406-23fa-4068-ad81-23b73b13e12f{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bf7e9482-ce9c-4986-b0fa-1e56f4ecd523",
  "data-name": "Details"
}, /*#__PURE__*/React.createElement("g", {
  id: "a34122f0-4e76-433c-ba2c-6d26ecd2dd42",
  "data-name": "datensatz objekt info"
}, /*#__PURE__*/React.createElement("path", {
  id: "be68037d-9b6b-46ba-a55e-7440fc83ad17",
  "data-name": "Fill-1",
  className: "e4783406-23fa-4068-ad81-23b73b13e12f",
  d: "M23.33,27h5.84V24H23.33Zm-12.5,0H16.7V24H10.83Zm0-12H29.17V13H10.83Zm12.5,8h5.84V20H23.33Zm-12.5,0H16.7V20H10.83Zm0-4H16.7V16H10.83Zm12.5,0h5.84V16H23.33Zm-5.79,0h5V16h-5Zm0,8h5V24h-5Zm0-4h5V20h-5Zm12-11H10.42a.46.46,0,0,0-.42.5v15a.46.46,0,0,0,.42.5H29.58a.46.46,0,0,0,.42-.5v-15a.46.46,0,0,0-.42-.5Z"
})));

var SvgIconTable = function SvgIconTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b02a04d3-50b0-4e4c-a1ac-e89ef5e62df9",
    "data-name": "Icons",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-table.b5fd4d20.svg";
export { ForwardRef as ReactComponent };